angular.module('dictionary')
    .directive('dictionaryPicker', function (Dictionary, DictionaryService) {
        return {
            restrict: 'E',
            require: 'ngModel',
            replace: false,
            scope: {
                type: "=",
                required: "=",
                onChange: "&",
                filterField: "=?",
                modelType: "=?",
                disableList: "=?",
                disableAdd: "=?",
                initialValue: "=?",
                placeholderKey: "@"
            },
            templateUrl: "app/dictionary/picker.html",
            link: function (scope, $element, $attrs, ngModelCtrl) {

                scope.placeholderKey = scope.placeholderKey || "select.choose"

                scope.filterStyle = scope.filterField || false
                scope.modelType = scope.modelType || "object"
                scope.disableList = scope.disableList || false
                scope.disableAdd = scope.disableAdd || false

                scope.executeOnChange = scope.onChange || angular.noop
                loadItems(scope.initialValue)

                function loadItems(initial){
                    Dictionary.list({type: scope.type}).$promise.then(items => {
                        scope.items = items

                        if(initial != null && typeof initial === "string"){
                            scope.selected = scope.items.find(i => i.name === initial)
                            scope.onSelectionChanged(scope.selected, scope.selected)
                        }
                    })
                }

                scope.add = () => DictionaryService.addModal(scope.type).then(() => loadItems())
                scope.list = () => DictionaryService.list(scope.type).then(() => loadItems())

                ngModelCtrl.$render = () => {
                    scope.selected = ngModelCtrl.$viewValue
                }
                ngModelCtrl.$formatters.push(modelValue => modelValue)
                ngModelCtrl.$parsers.push(viewValue => {
                    if(scope.modelType === "id")
                        return viewValue.id
                    else
                        return viewValue
                })

                scope.onSelectionChanged = ($item, $model) =>{
                    ngModelCtrl.$setViewValue($item)
                    ngModelCtrl.$validate()
                    ngModelCtrl.$render()
                    if (angular.isFunction(scope.executeOnChange())) {
                        scope.executeOnChange()($item)
                    }
                }
            }
        }
    })
